/* FS top bar (sections/announcement-bar): fade rotation, swipe (no arrows, owner 5 Oct 2026), pauses on hover/focus/hidden tab, static
   with reduced motion, announces only on user moves, drops a message when its countdown ends. */
customElements.get('fs-topbar') || customElements.define('fs-topbar', class extends HTMLElement {
  connectedCallback() {
    const t = this, on = (e, f, o) => t.addEventListener(e, f, o), D = document;
    const u = (n) => { t.s = 1; t.go(n, 1); t.run(); };
    t.m = [...t.querySelectorAll('.fs-topbar__msg')];
    t.i = 0;
    t.ms = t.dataset.speed * 1000;
    t.rm = matchMedia('(prefers-reduced-motion:reduce)');
    t.v = () => t.run();
    on('mouseenter', () => { t.h = 1; t.run(); });
    on('mouseleave', () => { t.h = 0; t.run(); });
    on('focusin', () => { t.f = 1; t.run(); });
    on('focusout', (e) => { if (!t.contains(e.relatedTarget)) { t.f = 0; t.run(); } });
    on('touchstart', (e) => { t.x = e.touches[0].clientX; }, { passive: true });
    on('touchend', (e) => { const d = e.changedTouches[0].clientX - t.x; Math.abs(d) > 40 && u(t.i + (d < 0 ? 1 : -1)); });
    on('fs-countdown:end', (e) => {
      const m = e.target.closest('.fs-topbar__msg'), k = t.m.indexOf(m);
      if (k < 0) return;
      t.m.splice(k, 1); m.remove();
      if (!t.m.length) t.closest('.fs-topbar').hidden = true;
      else { if (k < t.i) t.i--; t.go(t.i); }
      t.run();
    });
    if (window.Shopify && Shopify.designMode) {
      D.addEventListener('shopify:block:select', (e) => { const k = t.m.indexOf(e.target); if (k > -1) { t.s = 1; t.go(k); t.run(); } });
      D.addEventListener('shopify:block:deselect', () => { t.s = 0; t.run(); });
    }
    D.addEventListener('visibilitychange', t.v);
    t.querySelectorAll('fs-countdown').forEach((c) => c.dataset.end * 1e3 > Date.now() || c.dispatchEvent(new CustomEvent('fs-countdown:end', { bubbles: true })));
    t.run();
  }
  disconnectedCallback() { clearInterval(this.tm); document.removeEventListener('visibilitychange', this.v); }
  run() {
    clearInterval(this.tm);
    if (this.ms && !this.s && !this.h && !this.f && !document.hidden && !this.rm.matches && this.m.length > 1)
      this.tm = setInterval(() => this.go(this.i + 1), this.ms);
  }
  go(n, say) {
    const l = this.m.length, a = this.querySelector('.fs-topbar__live');
    this.i = (n + l) % l;
    this.dataset.moved = '';
    this.m.forEach((m, k) => { const o = k == this.i; m.classList.toggle('is-active', o); m.inert = !o; o ? m.removeAttribute('aria-hidden') : m.setAttribute('aria-hidden', 'true'); });
    if (say && a) a.textContent = this.m[this.i].innerText.replace(/\s+/g, ' ').trim();
  }
});
